import React, { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import { liveService } from "@/api/services";

export default function LiveScoresTicker() {
    const [matches, setMatches] = useState([]);

    useEffect(() => {
        let cancelled = false;
        const load = async () => {
            try {
                const data = await liveService.scores();
                if (!cancelled) setMatches(Array.isArray(data) ? data : []);
            } catch (err) {
                if (!cancelled) {
                    // eslint-disable-next-line no-console
                    console.warn("Live scores ticker failed:", err?.message || err);
                    setMatches([]);
                }
            }
        };
        load();
        const interval = setInterval(load, 60000);
        return () => {
            cancelled = true;
            clearInterval(interval);
        };
    }, []);

    // Hide the ticker entirely when there are no live matches — cleaner look
    // than showing a "no live fixtures" placeholder.
    if (matches.length === 0) return null;

    return (
        <div
            className="border-y border-border py-3 bg-background"
            data-testid="live-ticker"
        >
            <Marquee gradient={false} speed={45} pauseOnHover>
                {matches.map((m) => (
                    <span
                        key={m.id}
                        className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-300"
                    >
                        <span className="text-red-500 mr-2 live-dot inline-block w-1.5 h-1.5 rounded-full bg-red-500" />
                        {m.home} {m.goals?.home ?? 0}:{m.goals?.away ?? 0} {m.away}
                        <span className="ml-2 text-primary">
                            {m.status?.elapsed ? `${m.status.elapsed}'` : m.status?.long}
                        </span>
                        <span className="tick-sep" />
                    </span>
                ))}
            </Marquee>
        </div>
    );
}
